import { Router, RouterModule } from '@angular/router';
import {
  Component,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  Brand,
  PageTitle,
} from '../../../../../utils/models/layout.interface';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TopnavbarBreadcrumbComponent } from '../topnavbar-breadcrumb/topnavbar-breadcrumb.component';
import { EmitterService } from 'src/app/service/emitter/emitter.service';
import { NavigationBrandLogoComponent } from '../navigation-brand-logo/navigation-brand-logo.component';
import { NotificationsBellComponent } from '../notifications-bell/notifications-bell.component';
import { TopnavbarProfileComponent } from '../topnavbar-profile/topnavbar-profile.component';
import { TooltipComponent } from '../../miscelanea/tooltip/tooltip.component';
import { SimpleIndexedDB } from 'src/app/service/indexedDB/indexedDB.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-topnavbar',
  templateUrl: './topnavbar.component.html',
  styleUrls: ['./topnavbar.component.scss'],
  imports: [
      CommonModule,
      NavigationBrandLogoComponent,
      NotificationsBellComponent,
      TopnavbarProfileComponent,
      TopnavbarBreadcrumbComponent,
      SharedModule,
      RouterModule,
    ],
  standalone: true
})
export class TopnavbarComponent {
  @Input() pageTitles: PageTitle[];
  @Input() title: string;
  @Input() breakpoint: boolean;
  @Input() brand: Brand;
  @Input() link;
  @Output() collapse = new EventEmitter();
  @Output() changeGantt = new EventEmitter();

  @Input() drawer: any;

  fullScreen = false;
  isHandset$: Observable<boolean>

  constructor(
    public router: Router,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly emmiterService: EmitterService
  ) {
    this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches))
  }

  selectTitle(path: string): Object {
    if (path) {
      interface PathMapping {
        match: string;
        replace: string;
      }
    
      const pathMappings: PathMapping[] = [
        { match: '/cenarios/initial-condition/', replace: '/cenarios/initial-condition/:id' },
        { match: '/cenarios/demands/l2/', replace: '/cenarios/demands/l2/:id' },
        { match: '/cenarios/demands/l3/', replace: '/cenarios/demands/l3/:id' },
        { match: '/cenarios/demands/aciaria/', replace: '/cenarios/demands/aciaria/:id' },
        { match: '/cenarios/demands/schedule/l3/', replace: '/cenarios/demands/schedule/l3/:id' },
        { match: '/cenarios/demands/schedule/aciaria/', replace: '/cenarios/demands/schedule/aciaria/:id' },
        { match: '/cenarios/demands/settings/l3/', replace: '/cenarios/demands/settings/l3/:id' },
        { match: '/cenarios/demands/settings/aciaria/', replace: '/cenarios/demands/settings/aciaria/:id' },
        { match: '/cenarios/demands/results/l2/', replace: '/cenarios/demands/results/l2/:id' },
        { match: '/cenarios/demands/results/l3/', replace: '/cenarios/demands/results/l3/:id' },
        { match: '/cenarios/demands/results/aciaria/', replace: '/cenarios/demands/results/aciaria/:id' },
      ];
    
      const foundMapping = pathMappings.find(mapping => path.includes(mapping.match));
      if (foundMapping) {
        path = foundMapping.replace;
      }
    }

    return this.pageTitles.find((page) => page.path === path)
      ? this.pageTitles.find((page) => page.path === path).name.split('-')
      : null;
  }

  returnTitleTopNavbar(obj: any): string {
    return obj?.length > 0 ? obj[obj.length - 1].trim() : 'Induxtry';
  }
  
  get scenarioName() {
    return this.emmiterService.currentScenarioName()
  }

  get historyDate() {
    return  this.emmiterService.currentTypeScenario() === 'aciaria' && this.router.url.includes('/cenarios/demands/aciaria') ? 
      this.emmiterService.deltaHistory() : 
      null
  }
  
  toggleFullScreen(): void {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => {
        this.fullScreen = true;
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          this.fullScreen = false;
        });
      }
    }
  }

  sendCollapse() {
    this.collapse.emit(true);
  }

  openMenu(){
    this.drawer.toggle()
  }

  handleClick(value1, value2) {
    const indexOf = value2.indexOf(value1);
    const newArray = indexOf !== -1 ? value2.slice(0, indexOf + 1) : value2;

    let resultado = newArray.join('-');
    resultado = resultado.replace(/\s+$/, '');

    let breakpoint: string
    this.pageTitles.forEach((item,index) => {
      if(item.name === resultado){
        breakpoint = item.path
      }
    })
    if(breakpoint){
      this.router.navigate([breakpoint])
    }
  }

  sendToRoute(title, index) {
    const routes = [
      'cenarios', // Cenarios
      'cenarios/initial-condition/', // Condição inicial
      'cenarios/demands/', // Demandas
      'cenarios/demands/schedule/', // Regime e paradas
      'cenarios/demands/settings/' // Parâmetros Operacionais
    ];

    const scenarioData: any = this.emmiterService.allScenaryData();

    // Verifica se o índice existe no array routes
    if (index === undefined || index < 0 || index >= routes.length) {
      return; // Não faz nada se o índice for inválido
    }

    if (index === 0) {
      this.router.navigate([`${routes[index]}`]);
    } else if (index > 1) { 
      this.router.navigate([`${routes[index]}${scenarioData.type}`, scenarioData._id]);
    } else {
      this.router.navigate([`${routes[index]}`, scenarioData._id]);
    }
  }

  openDQ() {
    window.open(`${environment.redirectUri}/assets/dq/dist/index.html`, '_blank');
  }

}
